import { takeLatest, select, put } from 'redux-saga/effects'

import { REMOVE_HARNESS } from 'actions/feature/harnesses'
import { resetOutputFloatingCircuits } from 'actions/feature/outputs'
import { resetConditionFloatingCircuits } from 'actions/feature/queries'

import { getAllFeatureHarnessFloatingCircuits } from 'selectors/feature/harnesses'
import { outputsToResetFloatingCircuits } from 'selectors/feature/outputs'
import { conditionsToResetFloatingCircuits } from 'selectors/feature/conditions'

export default function* watchRemoveHarness() {
  yield takeLatest(REMOVE_HARNESS, updateFloatingCircuits)
}

function* updateFloatingCircuits() {
  const availableFloatingCircuits = yield select(
    getAllFeatureHarnessFloatingCircuits
  )
  const outputIdsToReset = yield select((state) =>
    outputsToResetFloatingCircuits(state, { availableFloatingCircuits })
  )
  const conditionUrisToReset = yield select((state) =>
    conditionsToResetFloatingCircuits(state, { availableFloatingCircuits })
  )

  yield put(resetOutputFloatingCircuits(outputIdsToReset))
  yield put(resetConditionFloatingCircuits(conditionUrisToReset))
}
